import type { ReactNode } from 'react';

type IconProps = { size?: number; className?: string };

function Svg({ size = 20, className, children }: IconProps & { children: ReactNode }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      {children}
    </svg>
  );
}

export function IconMove(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M12 3v18M3 12h18" />
      <path d="M8 7L12 3l4 4M8 17l4 4 4-4M7 8L3 12l4 4M17 8l4 4-4 4" />
    </Svg>
  );
}
export function IconRotate(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M21 12a9 9 0 1 1-2.4-6.1" />
      <path d="M21 5v5h-5" />
    </Svg>
  );
}
export function IconScale(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M4 14v6h6M20 10V4h-6" />
      <path d="M20 4L4 20" />
    </Svg>
  );
}
export function IconLayFlat(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M4 19h16" />
      <path d="M7 15l5-10 5 10" />
    </Svg>
  );
}
export function IconPaint(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M7 20h4a2 2 0 0 0 2-2v-1H9a2 2 0 0 0-2 2z" />
      <path d="M14 17l5.2-5.2a2.5 2.5 0 0 0 0-3.5L16.7 5.8a2.5 2.5 0 0 0-3.5 0L8 11v6h6z" />
    </Svg>
  );
}
export function IconBlock(p: IconProps) {
  return (
    <Svg {...p}>
      <circle cx="12" cy="12" r="8" />
      <path d="M7 7l10 10" />
    </Svg>
  );
}
export function IconErase(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M4 16l8-8 6 6-6 6H7z" />
      <path d="M8 12l4 4" />
    </Svg>
  );
}
export function IconOverhang(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M5 19h14" />
      <path d="M7 19V9h6v6h4V5" />
    </Svg>
  );
}
export function IconCentre(p: IconProps) {
  return (
    <Svg {...p}>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 3v4M12 17v4M3 12h4M17 12h4" />
    </Svg>
  );
}
export function IconDrop(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M12 4v12" />
      <path d="M7 11l5 5 5-5" />
      <path d="M5 20h14" />
    </Svg>
  );
}
export function IconArrange(p: IconProps) {
  return (
    <Svg {...p}>
      <rect x="4" y="4" width="7" height="7" rx="1.2" />
      <rect x="13" y="4" width="7" height="7" rx="1.2" />
      <rect x="4" y="13" width="7" height="7" rx="1.2" />
    </Svg>
  );
}
export function IconDup(p: IconProps) {
  return (
    <Svg {...p}>
      <rect x="8" y="8" width="11" height="11" rx="1.5" />
      <path d="M6 16V6h10" />
    </Svg>
  );
}
export function IconDel(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M5 7h14" />
      <path d="M9 7V5h6v2" />
      <path d="M8 7l1 13h6l1-13" />
    </Svg>
  );
}
export function IconUpload(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M12 16V6" />
      <path d="M8 10l4-4 4 4" />
      <path d="M5 18h14" />
    </Svg>
  );
}
export function IconMenu(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M5 7h14M5 12h14M5 17h14" />
    </Svg>
  );
}
export function IconClock(p: IconProps) {
  return (
    <Svg {...p}>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v5l3 2" />
    </Svg>
  );
}
export function IconSettings(p: IconProps) {
  return (
    <Svg {...p}>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 4v2M12 18v2M4 12h2M18 12h2M6.3 6.3l1.4 1.4M16.3 16.3l1.4 1.4M17.7 6.3l-1.4 1.4M7.7 16.3l-1.4 1.4" />
    </Svg>
  );
}

export function IconUndo(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M9 14l-4-4 4-4" />
      <path d="M5 10h8a6 6 0 1 1 0 12H9" />
    </Svg>
  );
}
export function IconRedo(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M15 14l4-4-4-4" />
      <path d="M19 10h-8a6 6 0 1 0 0 12h4" />
    </Svg>
  );
}
